<template>
  <div class="row columns is-multiline">
    <template v-if="computedItems.length > 0">
      <div class="column is-one-third is-flex" v-for="item in computedItems" :key="item.title">
        <card :item="item" :highlight="search"></card>
      </div>
    </template>
    <template v-else>
      <div class="column is-one-third is-flex">
        <p>Ups! Nie mamy nic podobnego!</p>
      </div>
    </template>
  </div>
</template>

<script>
import Card from "./Card";

export default {
  name: "CardsList",
  components: { Card },
  props: ["items", "filter", "search"],
  methods: {
    intersectionCount(array1, array2) {
      let count = 0;
      for (let elem of array2) {
        if (array1.indexOf(elem) != -1) {
          count++;
        }
      }
      return count;
    },
  },
  computed: {
    computedItems() {
      if (this.filter !== null && this.filter !== undefined) {
        let filtered = [];
        for (let item of this.items) {
          if (item.slug == this.filter.slug) {
            continue;
          }
          item.intersection_count = this.intersectionCount(
            item.tags,
            this.filter.tags
          );
          if (item.intersection_count > 0) {
            filtered.push(item);
          }
        }
        filtered.sort(
          (elem1, elem2) => elem1.intersection_count < elem2.intersection_count
        );
        return filtered;
      }

      if (this.search !== null && this.search !== undefined) {
        let re = new RegExp(this.search, "i");
        let filtered = this.items.filter(
          (elem) =>
            elem.title.search(re) != -1 ||
            elem.description.search(re) != -1 ||
            elem.tags.join(" ").search(re) != -1
        );
        return filtered;
      }
      return this.items;
    },
  },
};
</script>
